export default __webpack_public_path__ + "static/media/link.cdad956b.png";